

export const guestUrls = {
    'home_page' : '/home',
}